import { useApi } from "@backstage/core-plugin-api";
import { Checkbox } from "@material-ui/core";
import React, { useState } from "react";
import { opsReviewApiRef } from "../../api/OpsReviewApi";

interface Props {
  data: any;
}

export const ArchivedCheckbox: React.FC<Props> = ({ data }): JSX.Element => {
  const api = useApi(opsReviewApiRef);

  const [archived, setArchived] = useState<boolean>(data.archived);

  const handleArchivedClick = async (repo: string, toArchive: boolean) => {
    setArchived(toArchive);
    await api.updateOwnership({
      repo,
      hasCatalogInfo: false,
      archived: toArchive,
      link: data.link,
    });
  };

  return (
    <Checkbox
      onChange={(_event: any) => handleArchivedClick(data.repo, !archived)}
      checked={archived}
    />
  );
};
